<div class="modal-container">
  <div class="modal-header">
    <h5 class="header-title">Redirect Site: {{ site.title }}</h5>
  </div>

  <div class="modal-body">
    <div class="content-form w-auto">
      <div class="form-group">
        <div class="form-field mb-4">
          <label for="redirectUrl">Redirect to URL:</label>
          <input type="url" name="redirectUrl" id="redirectUrl" [(ngModel)]="redirectUrl" class="input-wrapper input-dimensionless w-auto flex-grow-1" />
        </div>
        <p class="text-danger fst-italic">If you save a redirect URL, the current site will become inactive.
          <br>From then on, all visits to site URL will be automatically redirected to the URL you have set.
        </p>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" (click)="onDismiss('cancel')">Cancel</button>
    <button class="btn-main" (click)="onSubmit()">Save</button>
  </div>
</div>